import styled from "styled-components";
import { GoBackButton } from "../../../../../components/GoBackButton";
import { urlOperator } from "../../../../../utils/url";





export const GalleryNavigation = () => {
  return (
      <ViewNavigation>
        <Redirect>
          <GoBackButton
            description={"Powrót"}
            goToUrl={urlOperator.subcontractors}
          />
        </Redirect>
      </ViewNavigation>
  )  
};


const ViewNavigation = styled.div`
  margin-top: -10px;
  padding-left: 24px;
  // display: flex;
  padding-bottom: 24px;
  // flex-direction: column;
  // @media (min-width: 1025px) {
  //   max-width: 1400px;
  //   margin-left: 225px;
  //   margin-right: 50px;
  // }
`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
`;
